<template functional>
  <div class="i-expansion-card__container">
    <q-expansion-item v-bind="data.attrs" v-on="listeners" class="i-expansion-card" header-class="i-expansion-card-header"
      expand-icon-class="i-expansion-card-expand-icon" default-opened>
      <div class="i-expansion-card-body">
        <div class="i-expansion-card-body-content">
          <slot name="default" />
        </div>
        <div class="i-expansion-card-body-actions">
          <slot name="actions" />
        </div>
      </div>
    </q-expansion-item>
  </div>
</template>
<script>
import Vue from 'vue'
import { QExpansionItem } from 'quasar'

Vue.component('q-expansion-item', QExpansionItem)
export default {

}
</script>
<style lang="scss">
@import "@/styles/quasar.variables.scss";

.i-expansion-card__container {
  padding: 10px;
}

.i-expansion-card {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  color: $primary !important;
  color: var(--q-color-primary) !important;
  border-radius: 0.5em;
  &-header {
    color: $primary !important;
    color: var(--q-color-primary) !important;
  }
  &-expand-icon {
    color: $primary !important;
    color: var(--q-color-primary) !important;
  }
  &-body {
    padding: 0 2em;
  }

  &-body-content {
    margin-bottom: 1em;
    display: flex;
    flex-direction: row;
  }
  &-body-content > * {
    margin-bottom: 0.5em;
  }
  &-body-actions {
    margin-bottom: 1em;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
